import { useTranslation } from "react-i18next";
import { useStatusContext } from "/app/src/contexts/hooks/useStatusContext";

/**
 * Returns a system type indicator component if the current system type is one of "test", "development", or "trial". Otherwise, returns null.
 *
 * @returns {JSX.Element|null} The system type indicator element or null if no valid system type is present.
 */
export default function SystemTypeIndicator() {
  const { t } = useTranslation();
  const { systemType, loading } = useStatusContext();

  if (loading || !systemType) return null;

  const systemTypeStyles: Record<string, string> = {
    test: "bg-[#ffa000]",
    development: "bg-[#00c851]",
    trial: "bg-[#7828C8]",
    demo: "bg-[#1475D7]",
  };

  const bgClass = systemTypeStyles[systemType];

  if (!bgClass) return null;

  return (
    <div className={`px-[10px] ${bgClass}`}>
      <p
        className={`text-white ml-[10px] px-[10px] py-[5px] relative top-[10px] uppercase inline rounded-md ${bgClass}`}
      >
        {systemType} {t("translation:system")}
      </p>
    </div>
  );
}
